import { render, staticRenderFns } from "./AddDialog.vue?vue&type=template&id=2b7d526a&scoped=true&"
import script from "./AddDialog.vue?vue&type=script&lang=js&"
export * from "./AddDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddDialog.vue?vue&type=style&index=0&id=2b7d526a&scoped=true&lang=css&"
import style1 from "./AddDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7d526a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b7d526a')) {
      api.createRecord('2b7d526a', component.options)
    } else {
      api.reload('2b7d526a', component.options)
    }
    module.hot.accept("./AddDialog.vue?vue&type=template&id=2b7d526a&scoped=true&", function () {
      api.rerender('2b7d526a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rebateGoodsPool/components/AddDialog.vue"
export default component.exports